(ns teamoesterreich.admin-mode.component.org-selector

  (:require [clojure.string]
            [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [teamoesterreich.text.get-text :as txt]
            [teamoesterreich.util.helper :as h]
            [teamoesterreich.view-state :as v-state]
            [teamoesterreich.admin-mode.data.organisation :as d-organisation]
            [teamoesterreich.util.log :as log]
            [reagent-material-ui.icons.delete-forever :refer [delete-forever]]
            ))

;(in-ns 'teamoesterreich.admin-mode.component.org-selector)

(defn check-org-id [orgId {:keys [filter-organizationMain filter-organizationDepartment filter-organization]}]
  (let [orgId (str "" orgId)]
    ;(log/debug "check-org-id " orgId " " (clj->js filter-organizationDepartment) (clj->js filter-organization))
    (and
      (or (empty? filter-organizationMain) (reduce (fn [c f]
                                                     ;(log/debug "check-orgDep-id check " f "->" orgId)
                                                     (or c (re-matches (re-pattern (str f)) orgId)))
                                                   false filter-organizationMain))
      (or (empty? filter-organizationDepartment) (reduce (fn [c f]
                                                           ;(log/debug "check-orgDep-id check " f "->" orgId)
                                                           (or c (re-matches (re-pattern (str f)) orgId)))
                                                         false filter-organizationDepartment))
      (or (empty? filter-organization) (reduce (fn [c f]
                                                 ;(log/debug "check-org-id check " f "->" orgId)
                                                 (or c (re-matches (re-pattern (str f)) orgId)))
                                               false filter-organization))
      )))



(defn get-selector [!filter update-cb & [orgId-filters {:keys [] :as params}]]
  (let [_ (d-organisation/get-store-organisations)
        init-params {:border "1px solid #e2e2e2" :paddingLeft "10px" :multiple true :readonly false}
        params (merge init-params
                      params)
        !organisations (r/cursor v-state/app-state [:organisations])
        MAIN_LIST (into {} (or (d-organisation/get-main-multi-filter-list @!organisations orgId-filters) []))
        DEP_LIST (into {} (or (d-organisation/get-org-multi-filter-list @!organisations orgId-filters) []))
        DST_LIST (into {} (or (d-organisation/get-dest-multi-filter-list @!organisations orgId-filters) []))
        ;_ (log/debug "org-selector DEP_LIST ************** " (count @!organisations) (clj->js DEP_LIST) orgId-filters)
        ]
    [mui/grid
     {:container  true
      :direction  "row"
      :alignItems "flex-start"
      :justify    "center"
      :spacing    1
      :style      {:border (:border params) :paddingLeft (:paddingLeft params)}
      }

     ;; Organisation
     [mui/grid
      {:item true
       :md   3
       :xs   12
       }
      (let [val_ (or (get-in @!filter [:organizationMain]) [])]
        [mui/form-control
         {:fullWidth true}

         [mui/input-label (txt/txt :rights-level 1)]
         [mui/select
          {:multiple    true
           :renderValue (fn [vals] (reduce (fn [c e] (str (if (= "" c) "" (str c ","))
                                                          (or (get-in MAIN_LIST [e :organisation-name]) e)
                                                          )) "" vals))
           :value       val_
           :onChange    (fn [val]
                          (let [selectedList (h/event-value val)]
                            (swap! !filter assoc
                                   :organizationMain selectedList
                                   :filter-organizationMain
                                   (when (and selectedList (> (count selectedList) 0)) (reduce (fn [c e] (conj c (get-in MAIN_LIST [e :organisation-orgFilter]))) [] selectedList))
                                   :regFilter-organizationMain
                                   (if (and selectedList (> (count selectedList) 0)) (reduce (fn [c e] (str c "|" (get-in MAIN_LIST [e :organisation-orgFilter]))) "X" selectedList) ".*")))
                          (update-cb))
           }
          (when (> (count MAIN_LIST) 0)
            (for [[k v] (sort-by first MAIN_LIST)]
              ^{:key (str "ORG_LIST-" k)}
              [mui/menu-item {:value k}
               [mui/list-item-icon [mui/checkbox {:checked (some #{k} val_)}]]
               [mui/list-item-text (:organisation-name v)]
               ]
              ))
          ]])
      ]


     ;; OrganisationLandesverband
     [mui/grid
      {:item true
       :md   4
       :xs   8
       }

      (let [main-pattern (re-pattern (or (get-in @!filter [:regFilter-organizationMain]) ".*"))
            options_ (sort-by first (filter (fn [[k v]]
                                              ;(log/log "LV test" main-pattern k)
                                              (and
                                                (not= (:organisation-active v) false)
                                                (re-matches main-pattern k))
                                              ) DEP_LIST))
            selected_ (or (get-in @!filter [:organizationDepartment]) [])]
        [mui/form-control
         {
          :fullWidth true
          }
         [mui/input-label (txt/txt :rights-level 2)]
         [mui/select
          {:multiple    true
           :renderValue (fn [vals] (reduce (fn [c e] (str (if (= "" c) "" (str c ","))
                                                          (or (get-in DEP_LIST [e :organisation-name]) e)
                                                          )) "" vals))
           :value       selected_
           :onChange    (fn [val]
                          (let [selectedList (h/event-value val)]
                            (swap! !filter assoc
                                   :organizationDepartment selectedList
                                   :filter-organizationDepartment
                                   (when (and selectedList (> (count selectedList) 0)) (reduce (fn [c e] (conj c (get-in DEP_LIST [e :organisation-orgFilter]))) [] selectedList))
                                   :regFilter-organizationDepartment
                                   (if (and selectedList (> (count selectedList) 0)) (reduce (fn [c e] (str c "|" (get-in DEP_LIST [e :organisation-orgFilter]))) "X" selectedList) ".*")
                                   ))
                          (update-cb))
           }
          (when (> (count options_) 0)
            (for [[k v] options_]
              ^{:key (str "DEP_LIST-" k)}
              [mui/menu-item {:value k}
               [mui/list-item-icon [mui/checkbox {:checked (some #{k} selected_)}]]
               [mui/list-item-text (:organisation-name v)]
               ]))
          ]])
      ]

     ;; OrganisationDienststelle
     [mui/grid
      {:item true
       :md   4
       :xs   12
       }

      (let [main-pattern (re-pattern (or (get-in @!filter [:regFilter-organizationMain]) ".*"))
            dep-pattern (re-pattern (or (get-in @!filter [:regFilter-organizationDepartment]) ".*"))
            options_ (sort-by first (filter (fn [[k v]]
                                              ;(log/log "DST test" main-pattern dep-pattern k)
                                              (and
                                                (not= (:organisation-active v) false)
                                                (re-matches main-pattern k)
                                                (re-matches dep-pattern k)
                                                )
                                              ) DST_LIST))
            selected_ (or (get-in @!filter [:organization]) [])]
        [mui/form-control
         {
          :fullWidth true
          }
         [mui/input-label (txt/txt :rights-level 3)]
         [mui/select
          {:multiple    true
           :renderValue (fn [vals] (reduce (fn [c e] (str (if (= "" c) "" (str c ","))
                                                          (or (get-in DST_LIST [e :organisation-name]) e)
                                                          )) "" vals))
           :value       selected_
           :onChange    (fn [val]
                          (let [selectedList (h/event-value val)]
                            (swap! !filter assoc
                                   :organization selectedList
                                   :filter-organization
                                   (when (and selectedList (> (count selectedList) 0)) (reduce (fn [c e] (conj c (or (get-in DST_LIST [e :organisation-orgFilter]) (get-in DST_LIST [e :organisation-key])))) [] selectedList))
                                   :regFilter-organization
                                   (if (and selectedList (> (count selectedList) 0)) (reduce (fn [c e] (str c "|" (or (get-in DST_LIST [e :organisation-orgFilter]) (get-in DST_LIST [e :organisation-key])))) "X" selectedList) ".*")
                                   ))
                          (update-cb))
           }
          (when (> (count options_) 0)
            (for [[k v] options_]
              ^{:key (str "ORG_LIST-" k)}
              [mui/menu-item {:value k}
               [mui/list-item-icon [mui/checkbox {:checked (some #{k} selected_)}]]
               [mui/list-item-text (:organisation-name v)]
               ]))
          ]])
      ]

     [mui/grid
      {:item true
       :md   1
       :xs   4
       }
      [mui/form-control
       {:fullWidth true :style {:marginTop "13px" :marginLeft "-5px"}}

       (when-not (:readonly params)
         [mui/button
          {:style   {:marginLeft "-5px"}
           :onClick (fn [val]
                      (swap! !filter assoc
                             :organizationMain nil :organization nil :organizationDepartment nil
                             :filter-organizationMain nil :filter-organization nil :filter-organizationDepartment nil
                             :regFilter-organizationMain nil :regFilter-organization nil :regFilter-organizationDepartment nil)
                      (update-cb))}
          [delete-forever]])
       ]
      ]
     ]))





(defn get-selector-org [!filter update-cb & [orgId-filters {:keys [] :as params}]]
  (let [_ (d-organisation/get-store-organisations)
        init-params {:border "1px solid #e2e2e2" :paddingLeft "10px" :multiple true :readonly false}
        params (merge init-params
                      params)
        !organisations (r/cursor v-state/app-state [:organisations])
        MAIN_LIST (into {} (or (d-organisation/get-main-multi-filter-list @!organisations orgId-filters) []))
        DEP_LIST (into {} (or (d-organisation/get-org-multi-filter-list @!organisations orgId-filters) []))
        ]
    (log/debug "get-selector-org " (clj->js @!filter))
    [mui/grid
     {:container  true
      :direction  "row"
      :alignItems "flex-start"
      :justify    "center"
      :spacing    1
      :style      {:border (:border params) :paddingLeft (:paddingLeft params)}
      }

     ;; Organisation
     [mui/grid
      {:item true
       :md   5
       :xs   12
       }
      (let [val_ (or (get-in @!filter [:organizationMain]) [])]
        [mui/form-control
         {:fullWidth true}

         [mui/input-label (txt/txt :rights-level 1)]
         [mui/select
          {:multiple    true
           :renderValue (fn [vals] (reduce (fn [c e] (str (if (= "" c) "" (str c ","))
                                                          (or (get-in MAIN_LIST [e :organisation-name]) e)
                                                          )) "" vals))
           :value       val_
           :onChange    (fn [val]
                          (let [selectedList (h/event-value val)]
                            (swap! !filter assoc
                                   :organizationMain selectedList
                                   :regFilter-organizationMain
                                   (if (and selectedList (> (count selectedList) 0)) (reduce (fn [c e] (str c "|" (get-in MAIN_LIST [e :organisation-orgFilter]))) "X" selectedList) ".*")))
                          (update-cb))
           }
          (when (> (count MAIN_LIST) 0)
            (for [[k v] (sort-by first MAIN_LIST)]
              ^{:key (str "ORG_LIST-" k)}
              [mui/menu-item {:value k}
               [mui/list-item-icon [mui/checkbox {:checked (some #{k} val_)}]]
               [mui/list-item-text (:organisation-name v)]
               ]
              ))
          ]])
      ]



     [mui/grid
      {:item true
       :md   5
       :xs   8
       }

      (let [main-pattern (re-pattern (or (get-in @!filter [:regFilter-organizationMain]) ".*"))
            options_ (sort-by first (filter (fn [[k v]]
                                              (log/log "LV test" main-pattern k)
                                              (and
                                                (not= (:organisation-active v) false)
                                                (re-matches main-pattern k))
                                              ) DEP_LIST))
            selected_ (or (get-in @!filter [:organizationDepartment]) [])]
        [mui/form-control
         {
          :fullWidth true
          }
         [mui/input-label (txt/txt :rights-level 2)]
         [mui/select
          {:multiple    true
           :renderValue (fn [vals] (reduce (fn [c e] (str (if (= "" c) "" (str c ","))
                                                          (or (get-in DEP_LIST [e :organisation-name]) e)
                                                          )) "" vals))
           :value       selected_
           :onChange    (fn [val]
                          (let [selectedList (h/event-value val)]
                            (swap! !filter assoc
                                   :organizationDepartment selectedList
                                   :regFilter-organizationDepartment
                                   (if (and selectedList (> (count selectedList) 0)) (reduce (fn [c e] (str c "|" (get-in DEP_LIST [e :organisation-orgFilter]))) "X" selectedList) ".*")
                                   ))
                          (update-cb))
           }
          (when (> (count options_) 0)
            (for [[k v] options_]
              ^{:key (str "DEP_LIST-" k)}
              [mui/menu-item {:value k}
               [mui/list-item-icon [mui/checkbox {:checked (some #{k} selected_)}]]
               [mui/list-item-text (:organisation-name v)]
               ]))
          ]])
      ]

     [mui/grid
      {:item true
       :md   2
       :xs   4
       }
      [mui/form-control
       {:fullWidth true :style {:marginTop "13px"}}

       (when-not (:readonly params)
         [mui/button
          {:onClick (fn [val]
                      (swap! !filter assoc :regFilter-organizationMain nil :regFilter-organizationDepartment nil :organizationMain nil :organizationDepartment nil)
                      (update-cb))}
          [delete-forever]])
       ]
      ]

     ]))






(defn get-org-selector [!orgId & [orgId-filters {:keys [longRow readonly border paddingLeft] :as params}]]
  (log/debug "org-selector get-mask-selector DEP_LIST ************** " (str @!orgId) " * " (clj->js orgId-filters) " * " (clj->js params))
  (let [_ (d-organisation/get-store-organisations)
        init-params {:border "1px solid #e2e2e2" :paddingLeft "10px" :readonly false}
        params (merge init-params params)
        !organisations (r/cursor v-state/app-state [:organisations])
        MAIN_LIST (or (d-organisation/get-main-multi-filter-list @!organisations orgId-filters) [])
        DEP_LIST (or (d-organisation/get-org-multi-filter-list @!organisations orgId-filters) [])
        DST_LIST (or (d-organisation/get-dest-multi-filter-list @!organisations orgId-filters) [])
        !mainId (r/atom (d-organisation/get-first-fit-main MAIN_LIST @!orgId))
        !depId (r/atom (d-organisation/get-first-fit-dep DEP_LIST @!orgId))
        ]
    (fn []
      (log/debug "org-selector get-mask-selector DEP_LIST ************** orgId " (str @!orgId) " DBG:" (clj->js @!organisations))
      [mui/grid
       {:container  true
        :direction  "row"
        :alignItems "flex-start"
        :justify    (if longRow "flex-start" "center")
        :spacing    1
        :style      {:margin 0 :border (:border params) :paddingLeft (:paddingLeft params)}
        }
       [mui/grid (if longRow {:item true :md 3 :xs 12} {:item true :md 6 :xs 12})
        [mui/form-control
         {
          :fullWidth true
          }
         [mui/input-label (txt/txt :rights-level 1)]
         [mui/select
          {:multiple false
           :disabled (:readonly params)
           :value    @!mainId
           :onChange (fn [val]
                       (reset! !orgId (h/event-value val))
                       )
           }
          (when (> (count MAIN_LIST) 0)
            (for [[k v] (sort-by first MAIN_LIST)]
              ^{:key (str "MAIN_LIST-" k)} [mui/menu-item {:value k} (str (:organisation-name v))]))
          ]]]
       (when-not longRow [mui/grid {:item true :md 2 :xs 12}])

       (let [main-pattern (re-pattern (if (and @!mainId (not= @!mainId ""))
                                        (get-in @!organisations [@!mainId :organisation-orgFilter])
                                        (or (get-in @!organisations [@!orgId :organisation-orgFilter]) ".*")))
             _ (println "######################################### main-pattern " main-pattern  " main:" (clj->js (get-in @!organisations [@!mainId :organisation-orgFilter])))
             dep-options (sort-by first (filter (fn [[k v]]
                                                  (and
                                                    (not= (:organisation-active v) false)
                                                    (re-matches main-pattern k))
                                                  ) DEP_LIST))]
         (when (> (count dep-options) 0)
           [mui/grid (if longRow {:item true :md 3 :xs 12} {:item true :md 5 :xs 12})
            [mui/form-control {:fullWidth true}
             [mui/input-label (txt/txt :rights-level 2)]
             [mui/select
              {:multiple false
               :disabled (:readonly params)
               :value    @!depId
               :onChange (fn [val]
                           (reset! !orgId (h/event-value val))
                           )
               }
              (when (> (count dep-options) 0)
                (for [[k v] (sort-by first dep-options)]
                  ^{:key (str "DEP_LIST-" k)} [mui/menu-item {:value k} (:organisation-name v)]))
              ]]]))



       (let [main-pattern (re-pattern (if (and @!mainId (not= @!mainId ""))
                                        (get-in @!organisations [@!mainId :organisation-orgFilter])
                                        (or (get-in @!organisations [@!orgId :organisation-orgFilter]) ".*")))
             dep-pattern (re-pattern (if (and @!depId (not= @!depId ""))
                                       (get-in @!organisations [@!depId :organisation-orgFilter])
                                       (or (get-in @!organisations [@!orgId :organisation-orgFilter]) ".*")))
             dst-options (sort-by first (filter (fn [[k v]]
                                                  (and (not= (:organisation-active v) false)
                                                       (and (re-matches main-pattern k)
                                                            (re-matches dep-pattern k)))
                                                  ) DST_LIST))
             ]
         (when (> (count dst-options) 0)
           [mui/grid (if longRow {:item true :md 3 :xs 12} {:item true :md 5 :xs 12})

            [mui/form-control {:fullWidth true}
             [mui/input-label (txt/txt :rights-level 3)]
             [mui/select
              {:multiple false
               :disabled (:readonly params)
               :value    (if (get (into {} DST_LIST) @!orgId) @!orgId "")
               :onChange (fn [val] (reset! !orgId (h/event-value val)))
               }
              (for [[k v] dst-options]
                ^{:key (str "DST_LIST-" k)} [mui/menu-item {:key (str "org_" k) :value k} (:organisation-name v)])
              ]]]))

       ;[mui/grid (if longRow {:item true :md 2 :xs 4} {:item true :md 2 :xs 4})
       ; (pr-str   @!organisations)]
       [mui/grid (if longRow {:item true :md 2 :xs 4} {:item true :md 2 :xs 4})
        [mui/form-control
         {:fullWidth true :style {:marginTop "13px"}}

         (when-not (or (:readonly params) (:noDelete params))
           [mui/button
            {:onClick (fn [val] (reset! !orgId ""))}
            [delete-forever]])
         ]
        ]

       ]

      )))
